import { render, staticRenderFns } from "./RI-PH-Notice.vue?vue&type=template&id=58c8f2d4&scoped=true&"
import script from "./RI-PH-Notice.vue?vue&type=script&lang=js&"
export * from "./RI-PH-Notice.vue?vue&type=script&lang=js&"
import style0 from "./RI-PH-Notice.vue?vue&type=style&index=0&id=58c8f2d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c8f2d4",
  null
  
)

export default component.exports